export interface ParsedObject {
  [key: string]: string | undefined;
}

export interface IQueryParser {
  stringify(): string;

  get(key: string): string | undefined;

  set(key: string, value: string): this;
  set(object: ParsedObject): this;
}

export class QueryParser implements IQueryParser {
  private object: ParsedObject = {};
  private search: string;

  constructor(search: string | ParsedObject) {
    if (typeof search === 'string') {
      this.search = search;
      this.object = this.parse(search);
    } else {
      this.object = search;
      this.search = this.create(search);
    }
  }

  get(key: string): string | undefined {
    return this.object[key];
  }

  has(key: string): boolean {
    return !!this.object[key];
  }

  set(key: string, value: string): this;
  set(object: ParsedObject): this;
  set(key: string | ParsedObject, value?: string): this {
    if (typeof key === 'string') {
      this.object = { ...this.object, [key]: value };
    } else {
      this.object = { ...this.object, ...key };
    }

    this.search = this.create(this.object);

    return this;
  }

  remove(key: string): this {
    delete this.object[key];
    
    this.search = this.create(this.object);

    return this;
  }

  stringify(): string {
    return this.search;
  }

  private parse(search: string): ParsedObject {
    if (search.startsWith('?')) {
      search = search.slice(1);
    }

    const pairs = search.split('&');

    return pairs.reduce<ParsedObject>((result, pair) => {
      const [key, value] = pair.split('=');

      if (value) {
        result[key] = value || undefined;
      }

      return result;
    }, {});
  }

  create(object: ParsedObject): string {
    const keys = Object.keys(object);
    const count = keys.length;
    const result = Object.keys(object).reduce<string>((result, key, index) => {
      const value = object[key] || '';
      const isLast = count - 1 === index;

      return result + `${key}=${value}${isLast ? '' : '&'}`;
    }, '');

    if (!result) {
      return '';
    }

    return `?${result}`;
  }

  toString(): string {
    return this.stringify();
  }
}
